
import Nav from "./index";
export default class NavView extends Nav {}
